import { AxiosRequestConfig } from "axios";
import { getApiUrl } from "../helpers/common";
import axios from "../utils/axios";

class Services
{
  async get<T = any>(url: string, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    return axios.get<T>(_url, config);
  }

  async post<T = any>(url: string, data: any, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    return axios.post<T>(_url, data, config);
  }

  async delete<T = any>(url: string, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    return axios.delete<T>(_url, config);
  }

  async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    return axios.put<T>(_url, data, config);
  }

  async patch<T = any>(url: string, data: any, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    return axios.patch<T>(_url, data, config);
  }
  async postTasking<T = any>(url: string, data: any, config?: AxiosRequestConfig)
  {
    const _url = await getApiUrl(url);
    try
    {
      const res = await axios.post<T>(_url, data, config);

      return res;
    } catch (error: any)
    {

      return error
    }
  }




}

export default new Services();
